import { render, staticRenderFns } from "./AbstractPageComponent.vue?vue&type=template&id=4258a533&scoped=true&"
import script from "./AbstractPageComponent.vue?vue&type=script&lang=ts&"
export * from "./AbstractPageComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AbstractPageComponent.vue?vue&type=style&index=0&id=4258a533&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4258a533",
  null
  
)

export default component.exports